import { render, staticRenderFns } from "./PurchaseOrderOptionsForAdmin.vue?vue&type=template&id=95905080&"
import script from "./PurchaseOrderOptionsForAdmin.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderOptionsForAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports